import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ProfileContainerComponent } from './profile.container';
import { DataTablesComponent } from './data-tables/data-tables.component';
import { DetailsComponent } from './details/details.component';
import { PreferencesComponent } from './preferences/preferences.component';

import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { ProfileEffects } from './profile.effects';
import { SharedModule } from '../../shared/shared.module';
import { ProfileReportsComponent } from './reports/reports.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { AccordionModule } from 'atlas-accordion';
import { AvatarModule } from 'atlas-avatar';
import { ButtonModule } from 'atlas-button';
import { CardModule } from 'atlas-card';
import { CheckboxModule } from 'atlas-checkbox';
import { FieldModule } from 'atlas-field';
import { IconModule } from 'atlas-icon';
import { PaginationModule } from 'atlas-pagination';
import { TableModule } from 'atlas-table';
import { TabsModule } from 'atlas-tabs';
import { SwitchModule } from 'atlas-switch';
export const COMPONENTS = [
  ProfileContainerComponent,
  DataTablesComponent,
  DetailsComponent,
  ProfileReportsComponent,
  PreferencesComponent,
  NotificationsComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    // // MercerOSModule,
    RouterModule,
    SharedModule,
    FieldModule,
    TabsModule,
    AvatarModule,
    CardModule,
    CheckboxModule,
    ButtonModule,
    IconModule,
    TableModule,
    PaginationModule,
    SwitchModule,
    EffectsModule.forFeature([ProfileEffects])
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [],
  bootstrap: [],
})
export class ProfileModule {
}
